module.exports = __webpack_public_path__ + "img/img12.6b28a0f5.svg";